import { supabase } from '@/integrations/supabase/client';
import { TablesInsert } from '@/integrations/supabase/types';

import { createCRUDEntity } from '../crud-factory';
import { transformTreatmentData } from '../transformations';

type TreatmentInsert = TablesInsert<'treatments'>;

// Treatment Entity
export const Treatment = createCRUDEntity('treatments', transformTreatmentData, {
  customMethods: {
    bulkCreate: async (treatmentsData: unknown[]) => {
      const { data, error } = await supabase
        .from('treatments')
        .insert(treatmentsData as TreatmentInsert[])
        .select();
      if (error) throw error;
      return data;
    },
  },
});
